import { Injectable } from '@angular/core';
import { CreateEffectMetadata } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { SciGuaduaHttpRequestHandler } from '@scifamek/guadua';
import { Observable } from 'rxjs';
import {
  CreateAgencyAdminCommand,
  GetAgencyAdminsByAgencyCommand,
  UpdateAgencyAdminCommand,
} from './agency-admin.commands';
import {
  CreatedAgencyAdminEvent,
  GottenAgencyAdminsEvent,
  UpdatedAgencyAdminEvent,
} from './agency-admin.events';
import { isCode } from '../../../shared/helpers/transaction.helpers';

@Injectable()
export class AgencyAdminEffects {
  prefix = 'agency-admin';
  createAgencyAdminCommand: Observable<Action<string>> & CreateEffectMetadata;
  updateAgencyAdminCommand: Observable<Action<string>> & CreateEffectMetadata;
  getAgencyAdminsByAgencyCommand: Observable<Action<string>> & CreateEffectMetadata;

  constructor(private sciGuaduaHttpRequestHandler: SciGuaduaHttpRequestHandler) {
    this.createAgencyAdminCommand = sciGuaduaHttpRequestHandler.handleEvent({
      command: CreateAgencyAdminCommand,
      prefix: this.prefix,
      others: (httpResponse, commandData) => {
        const response = [];
        if (isCode(httpResponse, CreatedAgencyAdminEvent)) {
          response.push(
            CreatedAgencyAdminEvent({
              agencyAdmin: httpResponse.data,
            }),
          );
        }
        return response;
      },
    });
    this.updateAgencyAdminCommand = sciGuaduaHttpRequestHandler.handleEvent({
      command: UpdateAgencyAdminCommand,
      prefix: this.prefix,

      others: (httpResponse, commandData) => {
        const response = [];
        if (isCode(httpResponse, UpdatedAgencyAdminEvent)) {
          response.push(
            UpdatedAgencyAdminEvent({
              agencyAdmin: httpResponse.data,
            }),
          );
        }
        return response;
      },
    });
    this.getAgencyAdminsByAgencyCommand = sciGuaduaHttpRequestHandler.handleEvent({
      command: GetAgencyAdminsByAgencyCommand,
      prefix: this.prefix,
      others: (httpResponse, commandData) => {
        const response = [];
        if (isCode(httpResponse, GottenAgencyAdminsEvent)) {
          response.push(
            GottenAgencyAdminsEvent({
              agencyAdmins: httpResponse.data,
            }),
          );
        }
        return response;
      },
    });
  }
}
